import { useContext } from 'react';
import { GradebookConfigContext } from "./GradebookConfigContext.js";
export var useGradebookConfig = function useGradebookConfig() {
  var context = useContext(GradebookConfigContext);
  if (!context) {
    throw new Error('useGradebookConfig must be used within GradebookConfigProvider');
  }
  return context;
};